<script lang="ts">
  import { onDestroy } from "svelte";
  import type { Snippet } from "svelte";
  import { focus } from "./actions/focus";
  import { trapFocus } from "./util";

  // export let ondismiss; // function
  interface Props {
    open?: boolean;
    closeOnEsc?: boolean;
    children?: Snippet;
  }

  let { open = $bindable(false), closeOnEsc = true, children }: Props = $props();

  let overlay = $state<HTMLElement>();

  function close() {
    open = false;
  }

  function handleClick(ev: MouseEvent) {
    if (ev.target == overlay) {
      // clicked on overlay => dismiss
      ev.stopPropagation();
      close();
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    // console.log("Overlay: handleKeyDown:", e);
    if (closeOnEsc && e.key === "Escape") {
      close();
      return;
    }

    if (e.key === "Tab") {
      if (overlay) {
        trapFocus(overlay, e);
      }
      e.preventDefault();
      return;
    }

    // needed to prevent arrow up / down etc. in FileList
    e.stopPropagation();
  }

  const previouslyFocused = document.activeElement as HTMLElement;
  if (previouslyFocused) {
    // console.log("Overlay: captured previouslyFocused:", previouslyFocused);
    onDestroy(() => {
      // console.log("Overlay: restoring focus to:", previouslyFocused);
      previouslyFocused.focus();
    });
  }
</script>

{#if open}
  <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
  <div
    role="button"
    tabindex="0"
    use:focus
    class="fm-overlay fixed inset-0 z-40 flex bg-black/50 text-black"
    bind:this={overlay}
    onclick={handleClick}
    onkeydown={handleKeyDown}
  >
    {@render children?.()}
  </div>
{/if}
